// extracted by mini-css-extract-plugin
module.exports = {"Sidemenu":"Sidemenu_Sidemenu__3SPr7","Buttons":"Sidemenu_Buttons__YOkrv","Disabled":"Sidemenu_Disabled__1nmHs","WhiteLogo":"Sidemenu_WhiteLogo__2eQAR"};